import PropTypes from 'prop-types';
import React, { forwardRef, useMemo } from 'react';

import classnames from 'classnames';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { useMobile, withWidget } from '@ezbobdev/ui-commons';

import Wrapper from './MaterialMobile.styled';

const ReactPhoneInputWrapper = forwardRef(function Phone(props, ref) {
  const {
    name,
    className,
    countryCode,
    disableDropdown,
    onlyCountries,
    countryCodeEditable,
    privacyRules,
    phoneMask,
    value,
    onChange,
    onBlur,
    preferredCountries,
    disableCountryCode,
    ...rest
  } = props;
  delete rest.formattingOptions;

  return (
    <ReactPhoneInput
      data-dd-privacy={privacyRules.input}
      disableCountryCode={disableCountryCode}
      preferredCountries={preferredCountries}
      countryCodeEditable={disableCountryCode || countryCodeEditable}
      disableDropdown={disableDropdown}
      country={countryCode}
      onlyCountries={onlyCountries}
      value={value}
      inputProps={{ ...rest, name, className, ref, type: 'tel' }}
      masks={{ [countryCode]: phoneMask }}
      onChange={(value, info, e) => {
        e.target.rawValue = value;

        onChange(e);
      }}
      onBlur={(e) => {
        e.target.rawValue = value;

        onBlur(e);
      }}
    />
  );
});

ReactPhoneInputWrapper.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  countryCode: PropTypes.string,
  countryCodeEditable: PropTypes.bool,
  onlyCountries: PropTypes.array,
  disableDropdown: PropTypes.bool,
  preferredCountries: PropTypes.arrayOf(PropTypes.string),
  privacyRules: PropTypes.object,
  phoneMask: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

const MaterialMobile = (props) => {
  const { name, className, fullWidth, reactPhoneInputProps } = props;

  const {
    value,
    countryCode,
    onlyCountries,
    countryCodeEditable,
    disableCountryCode,
    preferredCountries,
    disableDropdown,
    forceLtr,
    phoneMask,
    disabled,
    required,
  } = useMobile(props, MaterialMobile.displayName);

  return useMemo(() => {
    return (
      <Wrapper
        name={name}
        data-testid={`${name}-mobile`}
        disableDropdown={disableDropdown}
        disableCountryCode={disableCountryCode}
        forceLtr={forceLtr}
        disabled={disabled}
        className={classnames(MaterialMobile.displayName, name, className)}
        InputLabelProps={{ shrink: disableCountryCode ? undefined : true, required }}
        fullWidth={fullWidth}
        InputProps={{
          inputComponent: ReactPhoneInputWrapper,
          inputProps: {
            ...reactPhoneInputProps,
            value,
            countryCode,
            onlyCountries,
            preferredCountries,
            disableDropdown,
            countryCodeEditable,
            disableCountryCode,
            phoneMask,
          },
        }}
      />
    );
  }, [
    name,
    className,
    countryCode,
    reactPhoneInputProps,
    onlyCountries,
    countryCodeEditable,
    disableCountryCode,
    value,
    disableDropdown,
    forceLtr,
  ]);
};

MaterialMobile.displayName = 'MaterialMobile';

MaterialMobile.propTypes = {
  name: PropTypes.string.isRequired,
  configBy: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  muiTextFieldProps: PropTypes.object,
  reactPhoneInputProps: PropTypes.object,
};

export default React.memo(withWidget(MaterialMobile, { includeCaseMapProps: ['name'] }));
